import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saasApi, saasAuth } from '../../lib/api';
import PasswordInput from '../../components/PasswordInput.jsx';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  function set(field) {
    return (e) => setForm({ ...form, [field]: e.target.value });
  }

  async function submit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await saasApi.login(form);
      saasAuth.set(res.accessToken);
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-gray-50">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow">
        <h1 className="studio-uniform-title font-h2 text-h2 font-bold text-gray-900">Painel SaaS</h1>
        <p className="mt-1 text-[11px] text-gray-500">Acesso restrito à administração da plataforma.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="mb-1 block text-[11px] font-medium text-gray-700">E-mail</span>
            <input
              type="email"
              value={form.email}
              onChange={set('email')}
              autoComplete="email"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[11px] focus:border-blue-500 focus:outline-none"
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-[11px] font-medium text-gray-700">Senha</span>
            <PasswordInput
              value={form.password}
              onChange={set('password')}
              autoComplete="current-password"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 pr-10 text-[11px] focus:border-blue-500 focus:outline-none"
            />
          </label>
          {error && <p className="text-[11px] text-red-600">{error}</p>}
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-lg bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {busy ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}


